import {Component, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {InviteUserDialogComponent} from 'src/app/shared/invite-user-dialog/invite-user.dialog';
import {tap, filter, distinctUntilChanged} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-enterprise-users',
  templateUrl: './enterprise-users.component.html',
  styleUrls: ['./enterprise-users.component.scss']
})
export class EnterpriseUsersComponent implements OnInit {
  devMode = false;
  elements: any = [];
  isReady = false;
  isFreeTrial = true;
  canInviteUser = false;
  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };

  constructor(private trustiiService: TrustiiService, private matDialog: MatDialog, private sessionService: SessionService) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    this.canInviteUser = this.sessionService.canAddNewUser();
    this.isFreeTrial = this.sessionService.isFreePlan();
    this.getUsers();
  }

  /**
   * Get Users
   */
  getUsers(): void {
    this.trustiiService.getUsers(this.meta.page, this.meta.per_page).subscribe(
      (res) => {
        this.elements = res.data;
        this.meta = res.meta;
        this.meta.total = this.elements.length; // hack for now until we start filter data by modelId
        this.isReady = true;
      },
      (err) => {
        this.isReady = true;
        this.elements = [];
      }
    );
  }

  inviteUser(): void {
    this.matDialog.open(InviteUserDialogComponent, {
      height: '400px',
      width: '350px',
    }).afterClosed().pipe(
      distinctUntilChanged(),
      filter((result) => result && result.data === 'confirmation'),
      tap(() => this.refreshSession()),
      tap(() => this.isReady = false),
      tap(() => this.getUsers()),
    ).subscribe();
  }

  refreshSession(): void {
    this.sessionService.refreshUserObervable().subscribe(() => this.canInviteUser = this.sessionService.canAddNewUser());
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   * @return void
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getUsers();
  }

  /**
   * When page changed
   *
   * @param page The page
   * @return void
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getUsers();
  }
}
